import comp from "./LESelection";
export default comp;
